import { NOTIFICATION_ACTION_TYPE } from "../actions-type";

const initialState = {
  notifications: [],
  loading: false,
  hasNewNotification: 0,
  hasMore: true,
};

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATION_ACTION_TYPE.GET_NOTIFICATION:
      return {
        ...state,
        notifications: [...state.notifications, ...action.payload],
        hasMore: !(action.payload.length < 20),
        hasNewNotification: 0,
      };
    case NOTIFICATION_ACTION_TYPE.NOTIFICATION_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case NOTIFICATION_ACTION_TYPE.HAS_NEW_NOTIFICATION:
      return {
        ...state,
        hasNewNotification: action.payload,
      };
    case NOTIFICATION_ACTION_TYPE.RESET_NOTIFICATIONS:
      return {
        ...state,
        notifications: [],
        loading: false,
        hasMore: true,
      };

    default:
      return state;
  }
};

export default notificationsReducer;
